import { render, staticRenderFns } from "./AddOnboardingStepDialog.vue?vue&type=template&id=7c3714cf&scoped=true"
import script from "./AddOnboardingStepDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOnboardingStepDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddOnboardingStepDialog.vue?vue&type=style&index=0&id=7c3714cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3714cf",
  null
  
)

export default component.exports